import { useEffect, useRef, useState } from "react";

export function useVisibilityOnScroll() {
  const sectionsRef = useRef([]);
  const [visibilityStates, setVisibilityStates] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      const updatedStates = sectionsRef.current.map((section) => {
        if (!section) return false; // Skip invalid sections
        const rect = section.getBoundingClientRect();
        return rect.top < window.innerHeight * 0.85 && rect.bottom > window.innerHeight * 0.2;
      });
      setVisibilityStates(updatedStates);
    };

    handleScroll(); // Initial check
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return { sectionsRef, visibilityStates };
}
